import * as Sentry from "@sentry/react";

const DEFAULT_DSN =
  "https://66a20fa575afa50cb520daff5904f9d9@o4511396389191680.ingest.de.sentry.io/4511396392403024";

export function initSentry(): void {
  if (!import.meta.env.PROD) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN || DEFAULT_DSN;

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    ignoreErrors: ["ResizeObserver loop", "AbortError"],
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
